module.exports = __webpack_public_path__ + "1b88ec950b14b2cd180fd90dd93a52ce.png";